import gql from 'graphql-tag';

const CreateDeliveryEvent = gql(/* GraphQL */ `
  mutation CreateDeliveryEvent($input: CreateDeliveryEventInput!) {
    createDeliveryEvent(input: $input) {
      driverAssignment {
        id
        deliveryStatus
      }
      userErrors {
        ... on UserError {
          message
        }
      }
    }
  }
`);

export default CreateDeliveryEvent;
